export default __webpack_public_path__ + "static/media/boost.d2c91d8d.svg";